import React from "react";
import Info from "../component/candidate/Info";

const ReviewInfo = () => {
    return <div className="w-100 h-100">
        <Info/>
    </div>
}

export default ReviewInfo